"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingRewardsService = void 0;
var StakingRewards_json_1 = __importDefault(require("@orbs-network/orbs-ethereum-contracts-v2/build/contracts/StakingRewards.json"));
var mainnetAddresses_1 = require("../mainnetAddresses");
var cryptoUnitConverter_1 = require("../../utils/cryptoUnitConverter");
// DEV_NOTE : The value is between 0-100% with precision of 0.001,
//            The value is save as an integer in the contract, 0-100,000.
//            So we will need to divide/multiply when reading/writing.
var DELEGATORS_PERCENTAGE_FACTOR = 1000;
var MAIN_NET_STAKING_REWARDS_CONTRACT_ADDRESS = mainnetAddresses_1.ORBS_MAIN_NET_CONTRACT_ADDRESSES.stakingRewardsContract;
var StakingRewardsService = /** @class */ (function () {
    function StakingRewardsService(web3, rewardsContractAddress) {
        if (rewardsContractAddress === void 0) { rewardsContractAddress = MAIN_NET_STAKING_REWARDS_CONTRACT_ADDRESS; }
        this.web3 = web3;
        this.stakingRewardsContract = new this.web3.eth.Contract(StakingRewards_json_1.default.abi, rewardsContractAddress);
    }
    StakingRewardsService.prototype.setFromAccount = function (address) {
        this.stakingRewardsContract.options.from = address;
    };
    // **** Setting reading ****
    StakingRewardsService.prototype.readContractRewardsSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var settings, processedSettings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingRewardsContract.methods.getSettings().call()];
                    case 1:
                        settings = _a.sent();
                        processedSettings = {
                            defaultDelegatorsStakingRewardsPercent: percentageFromMillies(parseInt(settings.defaultDelegatorsStakingRewardsPercentMille)),
                            maxDelegatorsStakingRewardsPercent: percentageFromMillies(parseInt(settings.maxDelegatorsStakingRewardsPercentMille)),
                        };
                        return [2 /*return*/, processedSettings];
                }
            });
        });
    };
    StakingRewardsService.prototype.readGuardianRewardsSettings = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var rawGuardianRewardsSettings, guardianRewardsSettings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingRewardsContract.methods
                            .guardiansRewardSettings(address)
                            .call()];
                    case 1:
                        rawGuardianRewardsSettings = _a.sent();
                        guardianRewardsSettings = {
                            delegatorsStakingRewardsPercent: percentageFromMillies(parseInt(rawGuardianRewardsSettings.delegatorsStakingRewardsPercentMille)),
                            isUsingDefaultRewardsPercent: !rawGuardianRewardsSettings.overrideDefault,
                        };
                        return [2 /*return*/, guardianRewardsSettings];
                }
            });
        });
    };
    // **** Reading ****
    StakingRewardsService.prototype.readDelegatorsCutPercentage = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var cutPercentageInMillies, cutPercentage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingRewardsContract.methods
                            .getGuardianDelegatorsStakingRewardsPercentMille(address)
                            .call()];
                    case 1:
                        cutPercentageInMillies = _a.sent();
                        cutPercentage = percentageFromMillies(parseInt(cutPercentageInMillies));
                        return [2 /*return*/, cutPercentage];
                }
            });
        });
    };
    StakingRewardsService.prototype.readRewardsBalanceFullOrbs = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var stakingRewardsBalance, delegatorStakingRewardsBalanceFullOrbs, guardianStakingRewardsBalanceFullOrbs, stakingRewardsBalanceFullOrbs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingRewardsContract.methods
                            .getStakingRewardsBalance(address)
                            .call()];
                    case 1:
                        stakingRewardsBalance = _a.sent();
                        delegatorStakingRewardsBalanceFullOrbs = cryptoUnitConverter_1.fullOrbsFromWeiOrbs(stakingRewardsBalance.delegatorStakingRewardsBalance);
                        guardianStakingRewardsBalanceFullOrbs = cryptoUnitConverter_1.fullOrbsFromWeiOrbs(stakingRewardsBalance.guardianStakingRewardsBalance);
                        stakingRewardsBalanceFullOrbs = delegatorStakingRewardsBalanceFullOrbs + guardianStakingRewardsBalanceFullOrbs;
                        return [2 /*return*/, stakingRewardsBalanceFullOrbs];
                }
            });
        });
    };
    StakingRewardsService.prototype.readClaimedRewardsFullOrbs = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var delegatorStakingRewards, guardianStakingRewards, claimedDelegatorsRewardsFullOrbs, claimedGuardiansRewardsFullOrbs, totalClaimedRewards;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingRewardsContract.methods
                            .delegatorsStakingRewards(address)
                            .call()];
                    case 1:
                        delegatorStakingRewards = _a.sent();
                        return [4 /*yield*/, this.stakingRewardsContract.methods
                                .guardiansStakingRewards(address)
                                .call()];
                    case 2:
                        guardianStakingRewards = _a.sent();
                        claimedDelegatorsRewardsFullOrbs = cryptoUnitConverter_1.fullOrbsFromWeiOrbs(delegatorStakingRewards.claimed);
                        claimedGuardiansRewardsFullOrbs = cryptoUnitConverter_1.fullOrbsFromWeiOrbs(guardianStakingRewards.claimed);
                        totalClaimedRewards = claimedDelegatorsRewardsFullOrbs + claimedGuardiansRewardsFullOrbs;
                        return [2 /*return*/, totalClaimedRewards];
                }
            });
        });
    };
    StakingRewardsService.prototype.estimateFutureRewardsFullOrbs = function (address, durationInSeconds) {
        return __awaiter(this, void 0, void 0, function () {
            var estimatedFutureRewards, estimatedDelegatorRewardsInFullOrbs, estimatedGuardianRewardsInFullOrbs, estimatedRewardsInFullOrbs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingRewardsContract.methods.estimateFutureRewards(address, durationInSeconds).call()];
                    case 1:
                        estimatedFutureRewards = _a.sent();
                        estimatedDelegatorRewardsInFullOrbs = cryptoUnitConverter_1.fullOrbsFromWeiOrbs(estimatedFutureRewards.estimatedDelegatorStakingRewards);
                        estimatedGuardianRewardsInFullOrbs = cryptoUnitConverter_1.fullOrbsFromWeiOrbs(estimatedFutureRewards.estimatedGuardianStakingRewards);
                        estimatedRewardsInFullOrbs = estimatedDelegatorRewardsInFullOrbs + estimatedGuardianRewardsInFullOrbs;
                        return [2 /*return*/, estimatedRewardsInFullOrbs];
                }
            });
        });
    };
    // **** Writing ****
    StakingRewardsService.prototype.setDelegatorsCutPercentage = function (delegatorsCutPercentage) {
        var delegatorsCutInMillies = milliesFromPercentage(delegatorsCutPercentage);
        return this.stakingRewardsContract.methods
            .setGuardianDelegatorsStakingRewardsPercentMille(delegatorsCutInMillies)
            .send();
    };
    // **** Actions ****
    StakingRewardsService.prototype.claimRewards = function (address) {
        return this.stakingRewardsContract.methods.claimStakingRewards(address).send();
    };
    return StakingRewardsService;
}());
exports.StakingRewardsService = StakingRewardsService;
var milliesFromPercentage = function (percentage) {
    return percentage * DELEGATORS_PERCENTAGE_FACTOR;
};
var percentageFromMillies = function (millies) {
    return millies / DELEGATORS_PERCENTAGE_FACTOR;
};
//# sourceMappingURL=StakingRewardsService.js.map